import { Badge } from "src/components/Elements/Badge";

type CardUserRelationshipBadgeProps = {
  isOwner: boolean;
  isContributor: boolean;
  isCollaborator: boolean;
};

export const CardUserRelationshipBadge = ({
  isOwner,
  isContributor,
  isCollaborator,
}: CardUserRelationshipBadgeProps) => {
  const badgeLabel = isOwner
    ? "Organizer"
    : isCollaborator
      ? "Co-Organizer"
      : isContributor && isCollaborator
        ? "Co-Organizer"
        : isContributor
          ? "Contributor"
          : null;

  if (!badgeLabel) {
    return null;
  }

  return (
    <Badge variant="light" textSize="xs">
      {badgeLabel}
    </Badge>
  );
};
